export enum NotificationType {
  Alert = "Alert",
  Confirm = "Confirm",
  Snack = "Snack",
}
